export default function MobileBottomBar() {
  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 md:hidden">
      {/* 상단 강조 라인 */}
      <div className="h-0.5 bg-gradient-to-r from-teal-400 via-yellow-400 to-teal-400" />

      <div className="flex">
        {/* 전화 버튼 */}
        <a
          href="tel:0507-1366-2424"
          className="flex-1 flex flex-col items-center justify-center gap-1 py-3 bg-teal-600 active:bg-teal-700 transition-colors cursor-pointer"
        >
          <div className="w-6 h-6 flex items-center justify-center">
            <i className="ri-phone-fill text-white text-xl"></i>
          </div>
          <span className="text-white text-xs font-bold tracking-wide whitespace-nowrap">전화 상담</span>
          <span className="text-teal-200 text-[10px] font-medium whitespace-nowrap">0507-1366-2424</span>
        </a>

        {/* 구분선 */}
        <div className="w-px bg-teal-500/50" />

        {/* 카카오 버튼 */}
        <a
          href="https://open.kakao.com/o/sduqXZli"
          target="_blank"
          rel="noopener noreferrer"
          className="flex-1 flex flex-col items-center justify-center gap-1 py-3 bg-yellow-400 active:bg-yellow-500 transition-colors cursor-pointer"
        >
          <div className="w-6 h-6 flex items-center justify-center">
            <i className="ri-kakao-talk-fill text-gray-900 text-xl"></i>
          </div>
          <span className="text-gray-900 text-xs font-bold tracking-wide whitespace-nowrap">카카오 상담</span>
          <span className="text-gray-700 text-[10px] font-medium whitespace-nowrap">빠른 답변 가능</span>
        </a>
      </div>
    </div>
  );
}
